/* Cortezzo — Carrinho lateral
   Confete + brinde automático + Compre Junto
   Custom elements: reinicializam sozinhos quando o drawer é re-renderizado. */

(function () {
  'use strict';

  var STAGE_KEY = 'cortezzo_cart_stage';
  var PCT_KEY = 'cortezzo_cart_pct';
  var giftBusy = false;

  function getLastPct() {
    try {
      var v = sessionStorage.getItem(PCT_KEY);
      return v === null ? null : parseFloat(v);
    } catch (e) {
      return null;
    }
  }

  function setLastPct(v) {
    try {
      sessionStorage.setItem(PCT_KEY, String(v));
    } catch (e) {}
  }

  function getLastStage() {
    try {
      return parseInt(sessionStorage.getItem(STAGE_KEY) || '0', 10);
    } catch (e) {
      return 0;
    }
  }

  function setLastStage(v) {
    try {
      sessionStorage.setItem(STAGE_KEY, String(v));
    } catch (e) {}
  }

  function drawerEl() {
    return document.querySelector('cart-drawer');
  }

  /* =========================================================
     Confete — partículas menores, com flutuação e queda suave
     ========================================================= */
  var confettiRunning = false;

  function fireConfetti(host) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (confettiRunning) return;

    /* O canvas vai no <cart-drawer>, que NAO e substituido quando o
       carrinho re-renderiza. Dentro de #CartDrawer ele seria destruido
       no meio da animacao ao adicionar o brinde. */
    var stage = document.querySelector('cart-drawer') || host.closest('#CartDrawer');
    if (!stage) return;

    if (getComputedStyle(stage).position === 'static') {
      stage.style.position = 'relative';
    }

    var old = stage.querySelector('.cart-confetti');
    if (old) old.remove();

    confettiRunning = true;

    var canvas = document.createElement('canvas');
    canvas.className = 'cart-confetti';
    stage.appendChild(canvas);

    var rect = stage.getBoundingClientRect();
    var W = rect.width;
    var H = rect.height;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);

    canvas.width = W * dpr;
    canvas.height = H * dpr;
    var ctx = canvas.getContext('2d');
    ctx.scale(dpr, dpr);

    // paleta discreta, alinhada à marca
    var colors = ['#C9A227', '#E8C15F', '#D9A5A5', '#B4735C', '#F0E4CF', '#1a1a1a'];

    // origem: o nó do segundo estágio
    var node = host.querySelector('.cart-progress__node--2');
    var ox = W * 0.88;
    var oy = H * 0.14;
    if (node) {
      var nr = node.getBoundingClientRect();
      ox = nr.left - rect.left + nr.width / 2;
      oy = nr.top - rect.top + nr.height / 2;
    }

    var parts = [];
    var COUNT = 90;

    for (var i = 0; i < COUNT; i++) {
      var angle = -Math.PI / 2 + (Math.random() - 0.5) * 2.4;
      var speed = 2.5 + Math.random() * 5.5;
      parts.push({
        x: ox,
        y: oy,
        vx: Math.cos(angle) * speed * (0.7 + Math.random() * 0.9),
        vy: Math.sin(angle) * speed,
        w: 4 + Math.random() * 4,
        h: 6 + Math.random() * 5,
        rot: Math.random() * Math.PI * 2,
        vr: (Math.random() - 0.5) * 0.22,
        flutter: Math.random() * Math.PI * 2,
        vf: 0.08 + Math.random() * 0.1,
        color: colors[(Math.random() * colors.length) | 0],
        round: Math.random() < 0.25
      });
    }

    var start = performance.now();
    var DURATION = 6000;
    var FADE_FROM = 4300;

    function frame(now) {
      var t = now - start;
      ctx.clearRect(0, 0, W, H);

      for (var i = 0; i < parts.length; i++) {
        var p = parts[i];

        p.vy += 0.085; // gravidade
        p.vx *= 0.992; // arrasto
        p.x += p.vx;
        p.y += p.vy;
        p.rot += p.vr;
        p.flutter += p.vf;

        var alpha = t < FADE_FROM ? 1 : Math.max(0, 1 - (t - FADE_FROM) / (DURATION - FADE_FROM));
        if (alpha <= 0 || p.y > H + 30) continue;

        // "flutuação": achata horizontalmente como papel girando
        var squash = Math.abs(Math.cos(p.flutter));

        ctx.save();
        ctx.globalAlpha = alpha;
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.scale(Math.max(0.15, squash), 1);
        ctx.fillStyle = p.color;

        if (p.round) {
          ctx.beginPath();
          ctx.arc(0, 0, p.w / 2, 0, Math.PI * 2);
          ctx.fill();
        } else {
          ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        }
        ctx.restore();
      }

      if (t < DURATION) {
        requestAnimationFrame(frame);
      } else {
        confettiRunning = false;
        if (canvas.parentNode) canvas.parentNode.removeChild(canvas);
      }
    }

    requestAnimationFrame(frame);
  }

  /* =========================================================
     Brinde automático
     ========================================================= */
  function syncGift(el) {
    if (giftBusy) return;

    var variant = el.dataset.giftVariant;
    if (!variant) return;

    var eligible = el.dataset.eligible === 'true';
    var inCart = parseInt(el.dataset.giftQty || '0', 10) > 0;
    var key = el.dataset.giftKey;

    if (eligible && !inCart) {
      giftBusy = true;
      cartRequest('add', {
        items: [{ id: variant, quantity: 1, properties: { _brinde: 'true' } }]
      });
    } else if (!eligible && inCart && key) {
      giftBusy = true;
      cartRequest('change', { id: key, quantity: 0 });
    }
  }

  function cartRequest(endpoint, payload) {
    var drawer = drawerEl();

    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      payload.sections = drawer.getSectionsToRender().map(function (s) {
        return s.id;
      });
      payload.sections_url = window.location.pathname;
    }

    return fetch(window.Shopify.routes.root + 'cart/' + endpoint + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        giftBusy = false;
        if (data.status) throw new Error(data.description || 'Erro');
        if (drawer && data.sections) {
          drawer.renderContents(data);
        }
        return data;
      })
      .catch(function () {
        giftBusy = false;
      });
  }

  /* =========================================================
     <cart-progress>
     ========================================================= */
  if (!customElements.get('cart-progress')) {
    customElements.define(
      'cart-progress',
      class CartProgress extends HTMLElement {
        connectedCallback() {
          var stage = parseInt(this.dataset.stage || '0', 10);
          var last = getLastStage();

          /* Anima do valor anterior ate o atual, em vez de sempre do zero.
             Se o JS nao rodar, o CSS ja aplica a largura final. */
          var fill = this.querySelector('.cart-progress__fill');
          var pct = parseFloat(this.dataset.pct || '0');
          var prev = getLastPct();

          /* Regras da animacao:
             - primeira vez (sem valor anterior): anima de 0 ate o atual
             - valor mudou: anima do anterior ate o novo
             - valor IGUAL (ex: brinde gratis entrando, que nao altera o
               total): nao anima, a barra fica parada onde esta */
          var from = 0;
          var deveAnimar = true;

          if (prev !== null) {
            if (prev === pct) {
              deveAnimar = false;
            } else {
              from = prev;
            }
          }

          function runFill() {
            if (!fill || !deveAnimar) return;

            /* A LARGURA FINAL VEM DO CSS (--cart-pct, gerado pelo Liquid).
               O JS nunca a altera: assim a barra aparece correta mesmo que
               a animacao nao rode por qualquer motivo. */
            var ratio = pct > 0 ? from / pct : 0;
            if (ratio >= 1 || ratio < 0) ratio = 0;

            if (typeof fill.animate !== 'function') return;

            try {
              fill.animate(
                [{ transform: 'scaleX(' + ratio + ')' }, { transform: 'scaleX(1)' }],
                {
                  duration: 1100,
                  easing: 'cubic-bezier(0.16, 1, 0.3, 1)',
                  /* 'none' e proposital: fora da animacao o elemento volta
                     ao estado natural (largura cheia do --cart-pct).
                     Com 'both' ele ficaria preso em scaleX(0) se a
                     animacao nao disparasse. */
                  fill: 'none'
                }
              );
            } catch (e) {
              /* sem animacao: a barra ja esta correta pelo CSS */
            }
          }

          var drawer = document.querySelector('cart-drawer');
          var isOpen = drawer && (drawer.classList.contains('active') || drawer.classList.contains('animate'));

          if (isOpen || !drawer) {
            runFill();
          } else {
            // espera o drawer abrir
            var obs = new MutationObserver(function () {
              if (drawer.classList.contains('active')) {
                obs.disconnect();
                setTimeout(runFill, 380);
              }
            });
            obs.observe(drawer, { attributes: true, attributeFilter: ['class'] });
          }

          setLastPct(pct);

          if (stage === 2 && last < 2 && this.dataset.confetti === 'true') {
            var self = this;
            var d = document.querySelector('cart-drawer');
            if (d && !d.classList.contains('active')) {
              var o = new MutationObserver(function () {
                if (d.classList.contains('active')) {
                  o.disconnect();
                  setTimeout(function () { fireConfetti(self); }, 600);
                }
              });
              o.observe(d, { attributes: true, attributeFilter: ['class'] });
            } else {
              setTimeout(function () { fireConfetti(self); }, 500);
            }
          }

          if (stage !== last) setLastStage(stage);

          // brinde automático
          if (this.dataset.giftVariant) {
            var el = this;
            setTimeout(function () {
              syncGift(el);
            }, 60);
          }
        }
      }
    );
  }

  /* =========================================================
     <cart-upsell>
     ========================================================= */
  if (!customElements.get('cart-upsell')) {
    customElements.define(
      'cart-upsell',
      class CartUpsell extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          this.nav = this.querySelector('[data-nav]');
          if (!this.track) return;

          this.items = Array.from(this.track.children);
          this.index = 0;

          if (this.items.length > 1 && this.nav) {
            this.nav.hidden = false;
            var totalEl = this.nav.querySelector('[data-total]');
            if (totalEl) totalEl.textContent = this.items.length;

            var self = this;
            this.nav.querySelectorAll('[data-dir]').forEach(function (btn) {
              btn.addEventListener('click', function () {
                self.move(btn.dataset.dir === 'next' ? 1 : -1);
              });
            });

            this.track.addEventListener(
              'scroll',
              function () {
                self.syncIndex();
              },
              { passive: true }
            );

            this.updateCounter();
          }

          this.bindForms();
        }

        move(dir) {
          /* sem dar a volta: para no primeiro e no ultimo */
          var next = this.index + dir;
          if (next < 0) next = 0;
          if (next > this.items.length - 1) next = this.items.length - 1;
          if (next === this.index) return;

          this.index = next;
          this.scrollToIndex(next);
          this.updateCounter();
        }

        scrollToIndex(i) {
          var target = this.items[i];
          if (!target) return;

          /* posicao medida contra a propria trilha (offsetLeft usa o
             ancestral posicionado, o que dava valores errados) */
          var trackRect = this.track.getBoundingClientRect();
          var left =
            target.getBoundingClientRect().left - trackRect.left + this.track.scrollLeft;

          /* trava o recalculo enquanto a rolagem suave acontece,
             senao o evento de scroll sobrescreve o indice no meio */
          var self = this;
          this.lockSync = true;
          clearTimeout(this._syncTimer);
          this._syncTimer = setTimeout(function () {
            self.lockSync = false;
          }, 650);

          this.track.scrollTo({ left: left, behavior: 'smooth' });
        }

        syncIndex() {
          if (this.lockSync) return;

          var trackLeft = this.track.getBoundingClientRect().left;
          var closest = 0;
          var min = Infinity;

          for (var i = 0; i < this.items.length; i++) {
            var d = Math.abs(this.items[i].getBoundingClientRect().left - trackLeft);
            if (d < min) {
              min = d;
              closest = i;
            }
          }

          if (closest !== this.index) {
            this.index = closest;
            this.updateCounter();
          }
        }

        updateCounter() {
          var cur = this.querySelector('[data-current]');
          if (cur) cur.textContent = this.index + 1;

          var prev = this.querySelector('[data-dir="prev"]');
          var next = this.querySelector('[data-dir="next"]');
          if (prev) prev.disabled = this.index === 0;
          if (next) next.disabled = this.index === this.items.length - 1;
        }

        bindForms() {
          var self = this;
          this.querySelectorAll('[data-upsell-form]').forEach(function (form) {
            form.addEventListener('submit', function (e) {
              e.preventDefault();
              self.addItem(form);
            });
          });
        }

        addItem(form) {
          var btn = form.querySelector('button');
          if (btn.classList.contains('is-loading')) return;
          btn.classList.add('is-loading');
          btn.disabled = true;

          cartRequest('add', {
            items: [{ id: form.querySelector('[name="id"]').value, quantity: 1 }]
          }).then(function (data) {
            if (!data || data.status) {
              btn.classList.remove('is-loading');
              btn.disabled = false;
            }
          });
        }
      }
    );
  }
})();